document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.menu-list__link');
  const navItems = document.querySelectorAll('.menu-list__list-item');
  if (!navLinks.length) return;

  const pill = document.createElement('span');
  pill.classList.add('nav-pill');
  document.body.appendChild(pill);

  function movePillTo(link) {
    const linkRect = link.getBoundingClientRect();
    pill.style.width = linkRect.width + 'px';
    pill.style.left = linkRect.left + 'px';
    pill.style.top = linkRect.top + 'px';
    pill.style.height = linkRect.height + 'px';
    pill.style.opacity = '1';

    // Replay landing animation
    pill.classList.remove('is-landing');
    void pill.offsetWidth;
    pill.classList.add('is-landing');
  }

  const activeLink = document.querySelector('.menu-list__link--active');
  if (activeLink) movePillTo(activeLink);

  navItems.forEach(item => {
    const link = item.querySelector('.menu-list__link');
    if (link) item.addEventListener('mouseenter', () => movePillTo(link));
  });

  document.querySelector('.menu-list')?.addEventListener('mouseleave', () => {
    if (activeLink) movePillTo(activeLink);
  });
});